<template>
  <div class="approval-wrap">
    <div class="apply-info">
      <div class="info-title">
        <span class="line-icon"></span>
        申请信息
      </div>
      <div class="cnt">
        <div class="clear cnt-item">
          <div class="fl left">
            申请人：
            <span>{{detailData.driveName}}</span>
          </div>
          <div class="fl right">
            车牌号：
            <span>{{detailData.carNo}}</span>
          </div>
        </div>
        <div class="clear cnt-item">
          <div class="fl left">
            申请类型：
            <span>{{detailData.repaireTypeName}}</span>
          </div>
          <!-- <div class="fl right">紧急程度：<span>一般</span></div> -->
        </div>
        <div class="cnt-item tool-item">
          <div class>
            主要部件：
            <span>{{detailData.repaireParts?detailData.repaireParts.join('，'):''}}</span>
          </div>
        </div>
        <div class="cnt-item clear time-box">
          <div class="fl left">期望修理时间：</div>
          <div class="fl right">{{detailData.applyDate|dateFormat}}</div>
        </div>
        <div class="cnt-item clear detail-box">
          <div class="fl left">申请说明：</div>
          <div class="fl right">{{detailData.applyContent}}</div>
        </div>
        <div class="img-box ui-img-wrap">
          <ul class="img-ul clear">
            <li class="fl" v-for="(list,index) in (applyImgs?applyImgs:[])" :key="index">
              <div class="img">
                <img class="jMaxImg big-img" :src="list" @click="handleImg(index,1)" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="apply-info advice-info">
      <div class="info-title">
        <span class="line-icon"></span>
        审批意见
      </div>
      <div class="cnt">
        <div class="clear cnt-item">
          <div class="fl left">审批意见：</div>
          <div class="fl right">{{detailData.applyMsg}}</div>
        </div>
        <div class="clear cnt-item">
          <div class="fl left">维修厂：</div>
          <div class="fl right">{{detailData.repaireCompany}}</div>
        </div>
        <div class="clear cnt-item">
          <div class="fl left">维修地址：</div>
          <div class="fl right">{{detailData.repaireAddress}}</div>
        </div>
        <div class="clear cnt-item">
          <div class="fl left">联系人员：</div>
          <div class="fl right">{{detailData.repaireCompanyMan}}</div>
        </div>
        <div class="clear cnt-item">
          <div class="fl left">联系电话：</div>
          <div class="fl right">{{detailData.repairePhone}}</div>
        </div>
        <div class="cnt-item clear">
          <div class="fl left">维修时间：</div>
          <div class="fl right">{{detailData.repaireDate|dateFormat}}</div>
        </div>
      </div>
    </div>
    <div class="apply-info dec-info">
      <div class="info-title">
        <span class="line-icon"></span>
        维修描述
      </div>
      <div v-html="detailData.repaireDetail?detailData.repaireDetail:'暂无描述'"></div>
    </div>
    <div class="send-info">
      <div class="info-title">
        <span class="line-icon"></span>
        送车信息
      </div>
      <form>
        <div class="form-box clear">
          <label class="fl">车辆里程(km)：</label>
          <input
            class="fr"
            type="number"
            placeholder="请输入里程"
            v-model="addForm.carKm"
            @input="changeNum"
          />
          <!-- <div class="fr unit">km</div> -->
        </div>
        <div class="form-box clear">
          <label class="fl">车辆油量(L)：</label>
          <input class="fr" type="number" placeholder="请输入油量" v-model="addForm.carOil" />
          <!-- <div class="fr unit">L</div> -->
        </div>
        <div class="ui-img-wrap imgWrap">
          <p class="title jImgTile">油量表图（最多上传6张照片）</p>
          <ul class="img-ul clear">
            <li class="fl" v-for="(list,index) in imgArr" :key="index">
              <div class="img">
                <img class="jMaxImg big-img" :src="list" @click="handleImg(index,2)" />
                <img
                  class="icon-del jIconDel"
                  src="../../common/images/icon_del.png"
                  alt
                  @click="handleDelImg(index)"
                />
                <!-- //<i class='icon-del jIconDel'></i> -->
              </div>
            </li>
            <li class="fl last jLast" @click="handleUpdateImg" v-show="imgArr.length<6">
              <div class="img">
                <i class="line line1"></i>
                <i class="line line2"></i>
              </div>
            </li>
          </ul>
          <div class="swiperImg"></div>
        </div>
      </form>
    </div>
    <cover-img ref="applyImg" :imgArr="imgList"></cover-img>
    <!-- <cover-img ref="sendImg" :imgArr="imgArr"></cover-img> -->
    <div class="ui-button clear" :style="showStatic?staticStyle:fixStyle" @click="handleSend">保存</div>
  </div>
</template>
<script>
import utils from '../../common/js/utils'
import adjust from '../../common/js/adjust'
import coverImg from '../../components/coverImg'
import { formatDate } from '../../common/js/dateformat'
import { getRepaireDetail, getRepaireSendCar } from '../../api/maintenance'

export default {
  components: {
    coverImg
  },
  data () {
    return {
      detailData: {},
      repaireId: '',
      addForm: {
        carKm: '',
        carOil: '',
        carOilKmImages: '',
        repaireId: ''
      },
      applyImgs: [],
      // imgArr:['http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111328219571.jpg','http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111338540662.jpg ','http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111338540662.jpg ','http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111338540662.jpg ','http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111338540662.jpg ','http://p6w6s2i05.bkt.clouddn.com/rescue/images/CS1806300920038180630111338540662.jpg '],
      imgArr: [],
      totleImg: 6,
      imgList: [],
      type: '',
      iosVaild: utils.versions.ios,
      androidVaild: utils.versions.android,
      winHeight: document.body.clientHeight,
      showStatic: false,
      fixStyle: 'position:fixed',
      staticStyle: 'position:static',
      isSend: false,
      btnClick: true
    }
  },
  filters: {
    dateFormat (time) {
      if (time) {
        var date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
    }
  },
  methods: {
    changeNum () {
      if (this.addForm.carKm.length > 6) {
        this.addForm.carKm = this.addForm.carKm.slice(0, 6)
      }
    },
    // 删除图片
    handleDelImg (index) {
      this.imgArr.splice(index, 1)
    },
    // 从app获取到图片
    toImgValue (rst) {
      var _this = this
      var arr = rst ? rst.split(',') : ''
      if (!arr) return false
      if (arr.length <= 0) return false
      // imgFlag = imgArr.length;//用来标记上次传了几张图片
      arr.forEach(function (v, i) {
        _this.imgArr.push(v)
      })
      // _this.lightImgBox();
    },
    // app调用toImgValue方法
    appImgUrl () {
      var _this = this
      if (this.iosVaild) {
        utils.setupWebViewJavascriptBridge(function (bridge) {
          bridge.registerHandler('toImgValue', function (response, call) {
            _this.toImgValue(response)
          })
        })
      } else if (this.androidVaild) {
        window.toImgValue = function (str) {
          _this.toImgValue(str)
        }
      }
    },
    // 点击加号上传图片
    handleUpdateImg () {
      var len = this.totleImg - this.imgArr.length
      adjust.goAppUploader(len)
    },
    // handleSendImg(index){
    //     this.$refs.sendImg.viewImgSwiper = true;
    //     console.log(this.$refs.sendImg.swiperImgBox)
    //     if(this.$refs.sendImg.swiperImgBox){
    //         this.$refs.sendImg.swiperImgBox[1].slideTo(index, 50, false);
    //     }
    // },
    // 图片放大
    handleImg (index, type) {
      if (type == 1) {
        this.imgList = this.applyImgs
      } else if (type == 2) {
        this.imgList = this.imgArr
      }
      this.$refs.applyImg.viewImgSwiper = true
      if (this.$refs.applyImg.swiperImgBox) {
        this.$refs.applyImg.swiperImgBox.slideTo(index, 50, false)
      }
    },
    getDetailFun () {
      let para = {
        repaireId: this.repaireId
      }
      getRepaireDetail(para)
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data && res.data.errcode == 0 && res.data.data) {
              var data = res.data.data
              this.detailData = data
              if (this.detailData.applyImages) {
                this.applyImgs = this.detailData.applyImages.split(',')
              }
            } else {
              this.$toast(res.data.errmsg || '网络错误，请重试！')
            }
          } else {
            this.$toast(res.resMsg || '网络错误，请重试！')
          }
        })
        .catch(res => {})
    },
    handleSend () {
      var _this = this
      this.checkForm(() => {
        let para = Object.assign({}, this.addForm)
        para.repaireId = this.repaireId
        para.carOilKmImages = _this.imgArr.join(',')
        if (_this.btnClick) {
          _this.btnClick = false
          getRepaireSendCar(para)
            .then(res => {
              if (res && res.resCode == 0) {
                if (res.data && res.data.errcode == 0) {
                  this.isSend = true
                  this.$toast('送车成功')
                  setTimeout(function () {
                    if (_this.type == 1) {
                      _this.$router.push({ path: '/maintenance/list' })
                    } else if (_this.type == 2) {
                      _this.$router.push({ path: '/maintenance/myList' })
                    }
                  }, 2000)
                } else {
                  this.$toast(res.data.errmsg || '网络错误，请重试！')
                  _this.btnClick = true
                }
              } else {
                this.$toast(res.resMsg || '网络错误，请重试！')
                _this.btnClick = true
              }
            })
            .catch(res => {
              _this.btnClick = true
            })
        }
      })
    },
    checkForm (callback) {
      if (!this.addForm.carKm) {
        this.$toast('请输入车辆里程！')
        return false
      } else if (!this.addForm.carOil) {
        this.$toast('请输入车辆油量！')
        return false
      } else if (!this.imgArr) {
        this.$toast('请上传油量表图！')
        return false
      } else {
        callback && callback()
      }
    }
  },

  mounted () {
    var _this = this
    this.type = this.$route.params.type || ''
    this.repaireId = this.$route.params.repaireId || ''
    this.getDetailFun()
    this.appImgUrl()
    window.onresize = () => {
      if (_this.androidVaild) {
        var curHeight = document.body.clientHeight
        if (curHeight < _this.winHeight) {
          _this.showStatic = true
        } else {
          _this.showStatic = false
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isSend) {
      // to.meta.keepAlive = false;
      to.meta.isUpdate = true
    } else {
      to.meta.isUpdate = false
    }

    next()
  }
}
</script>
<style scoped lang="scss">
@import '../../styles/common';
.info-title {
  position: relative;
  line-height: 0.4rem;
  padding-left: 0.18rem;
  font-size: 0.32rem;
  color: rgb(51, 51, 51);
  margin-bottom: 0.32rem;
  .line-icon {
    position: absolute;
    left: 0rem;
    top: 0rem;
    width: 0.08rem;
    height: 0.4rem;
    background-color: rgb(38, 41, 56);
    @include border-radius(0.2rem);
  }
}
.approval-wrap {
  background-color: #f5f4f3;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  padding-bottom: 1rem;
  @include box-sizing(border-box);
  overflow: auto;
  .apply-info {
    padding: 0.32rem;
    @include box-sizing(border-box);
    background-color: #fff;
    margin-bottom: 0.16rem;
    .cnt {
      font-size: 0.3rem;
      color: rgb(51, 51, 51);
      .left,
      .right {
        width: 50%;
      }
      .cnt-item {
        line-height: 0.6rem;
      }
      .time-box,
      .detail-box {
        .left {
          width: 32%;
        }
        .right {
          width: 68%;
        }
      }
      .detail-box {
        .left {
          width: 25%;
        }
        .right {
          width: 75%;
        }
      }
    }
  }
  .advice-info {
    .cnt {
      .left {
        width: 25%;
      }
      .right {
        width: 75%;
      }
    }
  }
  .send-info {
    padding: 0.32rem;
    @include box-sizing(border-box);
    background-color: #fff;
  }

  .form-box {
    border-bottom: 1px solid #eeebe9;
    background-color: #fff;
    height: 1rem;
    line-height: 0.95rem;
    padding: 0 0.3rem;
    label {
      width: 40%;
      font-size: 0.28rem;
      color: rgb(51, 51, 51);
    }
    input,
    .right-select {
      width: 60%;
      border: 0 none;
      line-height: 0.95rem;
      height: 0.95rem;
      text-align: right;
      font-size: 0.28rem;
      &.active {
        color: rgb(51, 51, 51);
      }
    }
    .right-select {
      color: rgb(153, 153, 153);
    }
  }
  .unit-box {
    input {
      width: 60%;
      padding-right: 0.06rem;
      @include box-sizing(border-box);
    }
    .unit {
      width: 10%;
      font-size: 0.28rem;
      color: #333;
      height: 1rem;
      line-height: 1rem;
    }
  }
  .textarea-box {
    height: auto;
    margin-bottom: 0.1rem;
    textarea {
      display: block;
      border: 0 none;
      width: 100%;
    }
  }
}
.area_ctrl {
  background-color: #fff !important;
  .area_btn_box {
    background-color: #fff !important;
    &::before,
    &::after {
      background-color: #fff !important;
    }
  }
}
.ui-button {
  width: 100%;
  height: 1rem;
  background-color: rgb(251, 55, 91);
  text-align: center;
  line-height: 1rem;
  font-size: 0.32rem;
  color: #fff;
  cursor: pointer;
  .btn {
    width: 50%;
    &.btn1 {
      background-color: rgb(30, 135, 242);
    }
  }
}
</style>
